import { render, staticRenderFns } from "./IFrameUpload.vue?vue&type=template&id=ae61384c&"
import script from "./IFrameUpload.vue?vue&type=script&lang=js&"
export * from "./IFrameUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports